import { ttNormsFontFamily, ttNormsProBoldFontFamily, ttNormsVarFontFamily } from "../../../fonts/fonts";

/**
 * Font weight
 */
export const fontWeight = {
    thin: 100,
    extraLight: 200,
    light: 300,
    regular: 400,
    normal: 400,
    medium: 500,
    semiBold: 600,
    demiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900,
    extraBlack: 950,
} as const;

/**
 * Font Family
 */
export const fontFamily = {
    ttNormsPro: ttNormsFontFamily,
    ttNormsProVar: ttNormsVarFontFamily,
    /**
     * @deprecated Please use ttNormsPro or ttNormsProVar.
     */
    ttNorms: ttNormsProBoldFontFamily,
    inter: '"Inter", Arial, Helvetica, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";',
    interVar: '"Inter var", Arial, Helvetica, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";',
} as const;
